import { Navigate, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import HomePage from './pages/HomePage';
import QuoteEditorPage from './pages/QuoteEditorPage';
import TemplateEditorPage from './pages/TemplateEditorPage';
import ProductsPage from './pages/ProductsPage';
import ProductEditorPage from './pages/ProductEditorPage';
import PublicQuotePage from './pages/PublicQuotePage';
import CountersignPage from './pages/CountersignPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import NotFoundPage from './pages/NotFoundPage';
import QuoteReviewPage from './pages/QuoteReviewPage';
import McpConnectionPage from './pages/McpConnectionPage';
import { HubSpotAccessGate, HubSpotSessionBoundary } from './components/HubSpotAccessGate';
import QuotePdfDownloadPage from './pages/QuotePdfDownloadPage';
import QuoteHoursPage from './pages/QuoteHoursPage';

function App() {
  return (
    <ErrorBoundary level="page">
      <HubSpotSessionBoundary>
        <div className="min-h-screen bg-background">
          <Routes>
            <Route element={<HubSpotAccessGate />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/quotes" element={<HomePage />} />
              <Route path="/quotes/:id/edit" element={<QuoteEditorPage />} />
              <Route path="/quotes/:id/pdf" element={<QuotePdfDownloadPage />} />
              <Route path="/quotes/:id/hours" element={<QuoteHoursPage />} />
              <Route path="/quotes/:id/mcp" element={<McpConnectionPage />} />
              <Route path="/mcp" element={<McpConnectionPage />} />
              <Route path="/templates" element={<Navigate to="/?tab=templates" replace />} />
              <Route path="/templates/:id/edit" element={<TemplateEditorPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:id" element={<ProductEditorPage />} />
            </Route>
            <Route path="/q/:slug" element={<PublicQuotePage />} />
            <Route path="/countersign/:slug" element={<CountersignPage />} />
            <Route path="/review/:token" element={<QuoteReviewPage />} />
            <Route path="/auth/callback" element={<AuthCallbackPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
      </HubSpotSessionBoundary>
    </ErrorBoundary>
  );
}

export default App;
